import Vue from "vue";
import App from "./App.vue";
import VueResource from "vue-resource";
import VueRouter from "vue-router";
import VueCookies from 'vue-cookies';
import { routes } from "./routes";
import "./directives/Transform";
import VueAnalytics from "vue-analytics";
import i18n from "./i18n";

Vue.use(VueResource);
Vue.http.options.root = returnUrl();
Vue.use(VueRouter);
Vue.use(VueCookies);


const router = new VueRouter({
  routes: routes(i18n.messages[i18n.locale]),
  mode: "history"
});

Vue.use(VueAnalytics, {
  id: "UA-123261097-1",
  checkDuplicatedScript: true,
  router
});

new Vue({
  el: "#app",
  router,
  i18n,
  render: h => h(App)
});

function returnUrl() {
  let locale = window.location.host;

  switch (locale) {
    case "localhost:8081":
      return "https://back.stormsec.com.br";
      break;

    case "qa.stormsec.com.br":
      return "https://back.qa.stormsec.com.br/";
      break;

    case "stormsec.com.br":
      return "https://back.stormsec.com.br";
      break;
    default:
      return "https://back.stormsec.com.br";
  }
}



// WEBPACK FOOTER //
// ./src/main.js